import React from "react"
import styled from 'styled-components'

const WrapperStyled = styled.div`
  width: 100%;
  margin: 0 auto;
  transition: ease all .5s;
  scroll-behavior: smooth;
`

const PageWrapperStyled = ({children}) => {

  return (
    <WrapperStyled>
      {children}
    </WrapperStyled>
  )
}

export default PageWrapperStyled